import { AppPermission } from "@closerplatform/spinner-openapi";
import { observer } from "mobx-react";
import React from "react";
import { withPermissionFallback } from "../../components/HOC/withPermissionFallback/withPermissionFallback";
import { DashboardView } from "../dashboard/views/DashboardView";
import settingsStyles from "../settings/settings.css";
import { AiSuggestionsContent } from "./aiSuggestionsContent";
import { AiSuggestionNavigation } from "./aiSuggestionsNavigation";

export interface Props {
  view: DashboardView;
}

export const AiSuggestions = withPermissionFallback(
  AppPermission.SettingsAiSuggestions,
  observer(({ view }: Props) => {
    return (
      <div className={settingsStyles["settings-container"]}>
        <AiSuggestionNavigation view={view} />
        <AiSuggestionsContent view={view} />
      </div>
    );
  })
);
